import { takeLatestRequest } from "@/config/AxiosInstance";
import { API_BASE_URL_ADMIN, ENV } from "@/config/appConfig";

interface FetchAppThemeParams {
  url?: string;
  fk_brand_id?: number | string;
}

export function fetchAppTheme({ url, fk_brand_id }: FetchAppThemeParams = {}) {
  const reqData = {
    url: new URL(url || window.location.origin).origin,
    fk_brand_id: fk_brand_id || "",
  };
  const config = {
    method: "post",
    url: `${API_BASE_URL_ADMIN}/getWhiteLabelBrandData`,
    data: reqData,
    headers: { "x-api-key": ENV.PUBLIC_THEME_CLIENT_KEY },
  };
  return takeLatestRequest(config, "getWhiteLabelBrandData");
}

export function checkSubdomainExists(url = window.location.href) {
  const config = {
    method: "post",
    url: `${API_BASE_URL_ADMIN}/checkSubdomainExists`,
    data: { url },
    headers: { "x-api-key": ENV.PUBLIC_THEME_CLIENT_KEY },
  };
  return takeLatestRequest(config, "checkSubdomainExists");
}
